/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_AllowInputs */

const en_mcp_connect_allow = /** @type {(inputs: Mcp_Connect_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow access`)
};

const es_mcp_connect_allow = /** @type {(inputs: Mcp_Connect_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir acceso`)
};

/**
* | output |
* | --- |
* | "Allow access" |
*
* @param {Mcp_Connect_AllowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_allow = /** @type {((inputs?: Mcp_Connect_AllowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_AllowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_allow(inputs)
	return en_mcp_connect_allow(inputs)
});